<div style="position: absolute; top: 50%; width: 100%; text-align: center;">
  <p>
    {{emptyMsg | translate}}
  </p>
</div>
